import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { ApiConnectionListFacade } from './api-connection-list.facade';

@Injectable({
  providedIn: 'root',
})
export class ApiConnectionListGuard {
  constructor(private apiConnectionListFacade: ApiConnectionListFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.apiConnectionListFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.apiConnectionListFacade);
  }
}
